import * as React from "react";
import { cn } from "@/lib/utils";

export interface WizardStepProps {
  children: React.ReactNode;
  className?: string;
  columns?: 1 | 2;
  active?: boolean;
}

export const WizardStep = React.forwardRef<HTMLDivElement, WizardStepProps>(
  ({ children, className, columns = 1, active = false }, ref) => {
    if (!active) {
      return null;
    }

    return (
      <div
        ref={ref}
        className={cn(
          "w-full",
          columns === 2 ? "grid grid-cols-2 gap-6" : "",
          className
        )}
      >
        {children}
      </div>
    );
  }
);

WizardStep.displayName = "WizardStep";
